import { CustomerProductsTable } from "./table/customer-products/CustomerProductsTable";

export function CustomerPlansSection() {
	return <CustomerProductsTable />;
}
